/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Input} from '@angular/core';
import template from './creative-set-item-page.component.html';

import {AdminResourceItemPageBase} from '../common/controller/admin-resource-item-page-base';

@Component({
  standalone: false,
  selector: 'adn-creative-set-item-page',
  template
})
export class CreativeSetItemPageComponent extends AdminResourceItemPageBase {
  @Input() folioFromParam: any;
  @Input() advertiserFromParam: any;

  constructor(cdr: ChangeDetectorRef) {
    super(cdr);
  }
}
